module.exports = __webpack_public_path__ + "static/media/MyTasksNew.d23e27c6.svg";